import React from "react";
import axios from "axios";
import "../SalesTargetPerUser/SalesTargetPerUser.css";
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import PaginationLink from "../../../../../components/Pagination/Pagination";
import MiniDrawer from "../../../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useLocation } from "react-router-dom";

const SalesTargetPerUser = ({ setOpenStaffView, openStaffView }) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const heading = "Target History";

  const [userDetailResponse, setUserDetailResponse] = useState([]);

  const location = useLocation();

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetSalesTargetForUser?user_id=${location.state.user_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  function nextPage1() {

    const url = `/SalesTarget`;
    window.open(url, '_self');
  }

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Target History| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px",cursor:"pointer" }} onClick={nextPage1} >&gt; Target</span>{" "}
                <span style={{ fontSize: "20px" }}>&gt; Target List</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <div>
            <Wrapper className="ViewLeadDetails">
              {/* --------------master top button---------start---------- */}
              <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                <div className="headerButton">
                  <div>
                    {/* <button style={{ height: "53px", width: "101px" }}>
                      <FilterAltOutlinedIcon className="icon" />
                      Filters
                    </button> */}
                  </div>
                  {/* <div className="button-container">
                    <button onClick={() => {}}>
                    <AddIcon className="icon"/>
                      Add Target
                    </button>
                  </div> */}
                </div>

                <hr />
                <div>
                  <span style={{ fontSize: "25px" }}>{heading}</span>
                </div>
              </div>
              <div className="container-fluid">
                <div className="SalesTargetPerUser">
                  <table>
                    <tr className="SalesTargetPerUserHeading">
                      <th rowSpan={2}>S No.</th>
                      <th rowSpan={2}>Name</th>
                      <th rowSpan={2}>Month</th>
                      <th rowSpan={2}>Assigned Leads</th>
                      <th colSpan={2}>Target</th>
                      <th colSpan={2}>Target achieved</th>
                      <th rowSpan={2}>Conversion (%)</th>
                      <th rowSpan={2}>Revenue (%)</th>
                    </tr>
                    <tr className="SalesTargetPerUserHeading">
                      <th>Lead</th>
                      <th>Revenue</th>
                      <th>Lead</th>
                      <th>Revenue</th>
                    </tr>
                    {userDetailResponse !== null ? (
                      userDetailResponse.map((user, index) => (
                        <tr key={user.customer_id}>
                          <td>{++index}</td>
                          <td>{user.emp_name}</td>
                          <td>{user.target_for_month}</td>
                          <td>{user.assigned_leads}</td>
                          <td>{user.target_by_lead}</td>
                          <td>{user.target_by_revenue}</td>
                          <td>{user.target_achieved}</td>
                          <td>{user.target_achieved_revenue}</td>
                          <td>{user.conversions} %</td>
                          <td>{user.revenue_percentage} %</td>
                        </tr>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                  </table>
                </div>
              </div>
              <PaginationLink />
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesTargetPerUser;
